import AsyncControl from '@/Controls/AsyncControl';
import ComponentManager from '@/Management/ComponentManager';
import WizardGroupBoxViewModelType from '@/ViewModels/Controls/WizardGroupBoxViewModel';
import TabStripType from '@/Controls/TabStrip';
import GroupFactory from '@/Factories/GroupFactory';
import * as CoreFrameDTOs from "coreframetypings/dto";
import { IAsyncUserInteractable, IWizardGroupFactoryConstructorParameter } from '#/DefaultViewExtensionInterfaces';
import StateNotifier from '@/Utility/StateNotifier';

export default class WizardGroupBox extends AsyncControl implements IAsyncUserInteractable {

    private TabStrip = ComponentManager.getControl<typeof TabStripType>('TabStrip');
    private jQueryControl: JQuery;
    private content: JQuery;
    private tabStrip: TabStripType;

    public userInteractionPossibleNotifier: StateNotifier;

    public constructor(private viewModel: WizardGroupBoxViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.userInteractionPossibleNotifier = new StateNotifier();
    }

    public async getElementAsync(): Promise<JQuery> {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div></div>');
        this.content = $('<div class="c-content">').appendTo(this.jQueryControl);

        this.applyBindings(this.jQueryControl, {
            controlName: 'wizardgroupbox',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier
        });

        if (this.viewModel.parentTabStrip) {
            this.tabStrip = this.viewModel.parentTabStrip;
        }
        else if (this.viewModel.tabStrip != null) {
            this.tabStrip = new this.TabStrip(this.viewModel.tabStrip);
        }

        if (this.viewModel.tabStrip != null) {
            await this.createItemsAsync(this.viewModel.detailViewGroups, this.createGroupAsync);

            this.onAnyTabRendered(() => this.userInteractionPossibleNotifier.notify());

            if (this.tabStrip) {
                const tabStripTuple = this.tabStrip.getTuple();
                this.content.append(tabStripTuple.control);
            }

            this.widget(null);
        }

        return this.jQueryControl;
    }

    private onAnyTabRendered(action: () => void) {
        let anyRendered = false;
        for (const tab of this.viewModel.tabStrip.tabs) {
            this.subscribeUntil(tab.isRendered, rendered => {
                if (!anyRendered && rendered) {
                    action();
                }

                if (rendered)
                    anyRendered = true;

                return anyRendered;
            });
        }
    }

    private async createGroupAsync(g: CoreFrameDTOs.IDetailViewGroupDTO) {
        return GroupFactory.createInstanceAsync<IWizardGroupFactoryConstructorParameter>(g, this.viewModel.context, {
            tabStrip: this.viewModel.tabStrip,
            parentTabStrip: this.tabStrip,
            layout: this.viewModel.layout,
            isSummaryViewMode: this.viewModel.isSummaryViewMode,
            // Wir geben den Busy-State mit an die Kinder, damit diese den State des Parents beeinflussen können. Dies
            // ist in Ordnung, weil durch den TabStrip immer nur eine Gruppe sichtbar ist (Parent oder genau ein Kind).
            isBusy: this.viewModel.isBusy,
        });
    }
}

ComponentManager.setControl('WizardGroupBox', WizardGroupBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');